import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ParadigmaFileUploader.css';
import ParadigmaFileLink from './ParadigmaFileLink.js';

class ParadigmaFileUploader extends Component {
     constructor(props){
          super(props);
          this.waserased = false;
          this.fileInputRef = React.createRef();
          this.erase = this.erase.bind(this);
          this.fileadded = this.fileadded.bind(this);
     }

     static propTypes = {
         onChange: PropTypes.func.isRequired,
         erase: PropTypes.func,
	       name: PropTypes.string.isRequired,
         filename: PropTypes.string,
         link : PropTypes.string,
         acceptExtension: PropTypes.string,
         linkMessage : PropTypes.string
     }

     erase(){
          if(this.props.erase) this.props.erase();
          this.waserased = true;
     }

     fileadded(evt){
          if(evt.target.files !== undefined && evt.target.files.length == 1){
               if(this.props.onChange) this.props.onChange(evt);
               this.waserased = false;
          }
     }

     render() {
          let idInput = "files" + this.props.name;
          return (
               <div className="PFUBody">
                    <div className="PFUMessage">{this.props.message}</div>
                    <div>
                         <input
                         ref = {this.fileInputRef}
                         name={this.props.name}
                         type="file"
                         onChange={this.fileadded}
                         style={{display:'none' }}
                         accept = {this.props.acceptExtension}
                         />
                         <input type = "hidden" name = {this.props.name+"_erased"} value={this.waserased}/>
                         <button type="button" onClick={()=> this.fileInputRef.current.click()}>Adjuntar</button>
                         <button type="button" onClick={this.erase}>Borrar</button>
                         <ParadigmaFileLink message = {this.props.linkMessage} filename={this.props.filename} link={this.props.link}/>
                    </div>
               </div>
          );
     }
}

export default ParadigmaFileUploader;



// WEBPACK FOOTER //
// ./src/components/ParadigmaFileUploader/ParadigmaFileUploader.js